/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_components.table, {
    children: [_jsx(_components.thead, {
      children: _jsxs(_components.tr, {
        children: [_jsx(_components.th, {
          children: "Events"
        }), _jsx(_components.th, {
          children: "Description"
        })]
      })
    }), _jsxs(_components.tbody, {
      children: [_jsxs(_components.tr, {
        children: [_jsxs(_components.td, {
          children: [_jsx(_components.code, {
            children: "onOpen"
          }), " / ", _jsx(_components.code, {
            children: "on_open"
          })]
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " This event gets triggered once the modal shows up. Returns the modal id: ", _jsx(_components.code, {
            children: "{ id }"
          }), "."]
        })]
      }), _jsxs(_components.tr, {
        children: [_jsxs(_components.td, {
          children: [_jsx(_components.code, {
            children: "onClose"
          }), " / ", _jsx(_components.code, {
            children: "on_close"
          })]
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " this event gets triggered once the modal gets closed. Returns the modal id: ", _jsx(_components.code, {
            children: "{ id, event, triggeredBy }"
          }), "."]
        })]
      }), _jsxs(_components.tr, {
        children: [_jsxs(_components.td, {
          children: [_jsx(_components.code, {
            children: "onClosePrevent"
          }), " / ", _jsx(_components.code, {
            children: "on_close_prevent"
          })]
        }), _jsxs(_components.td, {
          children: [_jsx(_components.em, {
            children: "(optional)"
          }), " this event gets triggered once the user tries to close the modal, but ", _jsx(_components.code, {
            children: "prevent_close"
          }), " is set to ", _jsx(_components.strong, {
            children: "true"
          }), ". Returns a callback ", _jsx(_components.code, {
            children: "close"
          }), " you can call to trigger the close mechanism. More details below. Returns the modal id: ", _jsx(_components.code, {
            children: "{ id, event, close: Method, triggeredBy }"
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
